export default __webpack_public_path__ + "static/media/warning.5375ec96.svg";